// src/components/FeaturedImage.js
import React, { useState, useRef } from 'react';
import './FeaturedImage.css';

// Fast-loading image component optimized for featured products - instant display, no loading states
const FeaturedImage = ({ 
  src, 
  alt = '', 
  width = 300, 
  height = 300, 
  className = '',
  priority = false,
  onError,
  onLoad
}) => {
  const [imageError, setImageError] = useState(false);
  const imgRef = useRef(null);

  const handleLoad = (e) => {
    if (onLoad) onLoad(e);
  };

  const handleError = (e) => {
    setImageError(true);
    if (onError) onError(e);
  };

  // Container style with aspect ratio
  const containerStyle = {
    aspectRatio: `${width} / ${height}`,
    width: '100%',
    height: '100%'
  };

  const imageClasses = `featured-image ${className} ${imageError ? 'error' : ''}`;

  return (
    <div 
      className="featured-image-container"
      style={containerStyle}
    >
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        loading={priority ? 'eager' : 'auto'}
        fetchpriority={priority ? 'high' : 'auto'}
        className={imageClasses}
        width={width}
        height={height}
        onLoad={handleLoad}
        onError={handleError}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          display: 'block'
        }}
      />
    </div>
  );
};

export default FeaturedImage;
